if (!window.customElements.get('featured-products')) {
  class FeaturedProducts extends HTMLElement {
    constructor() {
      super();
      this.boundUpdateLargeClass = this.updateLargeClass.bind(this);
    }

    connectedCallback() {
      this.updateLargeClass();
      window.addEventListener('resize', this.boundUpdateLargeClass);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundUpdateLargeClass);
    }

    updateLargeClass() {
      const mobileStyle = this.getAttribute('data-mobile-card-style');
      const desktopStyle = this.getAttribute('data-desktop-card-style');
      const isMobile = window.innerWidth < 768;
      const isLarge = isMobile ? mobileStyle === 'large' : desktopStyle === 'large';
      if (isLarge) {
        this.classList.add('featured-products--large-cards');
      } else {
        this.classList.remove('featured-products--large-cards');
      }
    }
  }

  window.customElements.define('featured-products', FeaturedProducts);
}
